module.exports = __webpack_public_path__ + "img/summary_1.a513aed8.png";